import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WayfindingComponent } from './wayfinding/wayfinding.component';
import { PinchZoomModule } from 'ngx-pinch-zoom';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { BuscadorComponent } from './buscador/buscador.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { InformacionesComponent } from './informaciones/informaciones.component';
import { TiendasComponent } from './tiendas/tiendas.component';
import { EstacionamientosComponent } from './estacionamientos/estacionamientos.component';
import { CineComponent } from './cine/cine.component';
import { DondeEstoyComponent } from './donde-estoy/donde-estoy.component';
import { MiUbicacionComponent } from './mi-ubicacion/mi-ubicacion.component';
import { DondeQuieroIrComponent } from './donde-quiero-ir/donde-quiero-ir.component';
import { ProximamenteComponent } from './proximamente/proximamente.component';
import { CineDetalleComponent } from './cine-detalle/cine-detalle.component';
import { TiendaDetalleComponent } from './tienda-detalle/tienda-detalle.component';
import { AreasComponent } from './areas/areas.component';
import { OfertasComponent } from './ofertas/ofertas.component';
import { AutocompletarComponent } from './autocompletar/autocompletar.component';
import { EventoDetalleComponent } from './evento-detalle/evento-detalle.component';
import { NewMapComponent } from './new-map/new-map.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { NewFooterComponent } from './new-footer/new-footer.component';
import { MensajeQrComponent } from './mensaje-qr/mensaje-qr.component';
import { DesingTestComponent } from './desing-test/desing-test.component';

import { DragScrollModule } from 'ngx-drag-scroll';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting


@NgModule({
  declarations: [
    AppComponent,
    WayfindingComponent,
    PageNotFoundComponent,
    BuscadorComponent,
    HeaderComponent,
    FooterComponent,
    InformacionesComponent,
    TiendasComponent,
    EstacionamientosComponent,
    CineComponent,
    DondeEstoyComponent,
    MiUbicacionComponent,
    DondeQuieroIrComponent,
    ProximamenteComponent,
    CineDetalleComponent,
    TiendaDetalleComponent,
    AreasComponent,
    OfertasComponent,
    AutocompletarComponent,
    EventoDetalleComponent,
    NewMapComponent,
    QrcodeComponent,
    NewFooterComponent,
    MensajeQrComponent,
    DesingTestComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    PinchZoomModule,
    DragScrollModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCCLr-gdG0_e8UvyKwHdEHI_I9WxgVQ-ZA'
    }),
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
